// getters
export const GET_ROLES = "getRoles";
export const GET_CATEGORIES = "getCategories";
export const GET_SERVICES = "getServices";